<script setup lang="ts">
import type { Flat } from '~/types/types'
import { useGhostStuff, useState } from '#imports'

const Flats = useState<Record<number, Flat>>('Flats')
const ghostStuff = useGhostStuff()
</script>

<template>
  <svg
    viewBox="0 0 1400 730"
  >
    <!-- <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="259.8 245.6 259.7 303 218.2 303.6 218.1 319.9 210.4 319.9 210.4 329.3 146.3 329.4 146.2 256.9 77.1 256.8 77.1 172.5 206.1 172.8 206 151 282.4 151 282.4 245.5 259.8 245.6"
      @click="ghostStuff.openLink"
    /> -->
    <polygon
      id="2110"
      :class="['fill-ghost-'+Flats[2110]?.status_name, 'ghost-element']"
      points="259.8 245.6 259.7 303 292.6 303.2 292.7 298.6 313.6 298.2 313.8 289.1 321.5 289.2 321.8 303.3 361.6 303.6 361.5 246.7 404 247 404 150.8 282.6 150.8 282.6 245.6 259.8 245.6"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="2111"
      :class="['fill-ghost-'+Flats[2111]?.status_name, 'ghost-element']"
      points="470.4 330.2 470.4 337.2 556.6 337.4 556.6 256.9 532.8 256.7 532.4 172.8 404 172.8 404 247 361.5 246.7 361.6 303.6 377 303.4 402 303.3 402.2 330.2 470.4 330.2"
      @click="ghostStuff.openLink"
    />
    <!-- <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="556.6 415.3 556.7 574.2 458.1 573.8 457.9 494 402.2 493.7 402.2 415.5 556.6 415.3"
      @click="ghostStuff.openLink"
    /> -->
    <polygon
      id="2112"
      :class="['fill-ghost-'+Flats[2112]?.status_name, 'ghost-element']"
      points="556.6 415.5 556.6 337.2 470.4 337.2 470.4 330.4 402.2 330.4 402.2 415.5 556.6 415.5"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="2121"
      :class="['fill-ghost-'+Flats[2121]?.status_name, 'ghost-element']"
      points="532.8 574.1 458.1 573.8 458.1 493.9 402.2 493.7 402.1 507.7 372 507.8 372 560.9 400.3 560.9 400.3 658.2 532.8 658.2 532.8 574.1"
      @click="ghostStuff.openLink"
    />
    <!-- <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="371.8 512.4 346.8 512.3 346.7 507.7 259.9 507.8 259.9 572.9 209.8 572.9 209.6 631 400.4 630.5 400.3 560.9 372 560.9 371.8 512.4"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="53.4 415.3 53.4 574.2 146.2 573.8 146.4 493.9 168.3 493.7 168.3 502.7 210 502.8 210.2 465.7 216.3 465.9 216.3 473.8 259.8 474 259.8 415.5 53.4 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="53.4 415.5 53.4 256.9 146.2 256.9 146.3 329.4 210.4 329.3 210.9 336.7 259.4 336.7 259.5 415.5 53.4 415.5"
      @click="ghostStuff.openLink"
    /> -->
    <polygon
      id="2122"
      :class="['fill-ghost-'+Flats[2122]?.status_name, 'ghost-element']"
      points="77.2 574.1 146.2 573.8 146.4 493.9 168.1 493.7 168.3 502.7 210 502.8 210.4 512.1 216 512.1 216.3 507.7 259.8 507.8 259.8 573 209.8 572.9 209.7 658.2 77.2 658.2 77.2 574.1"
      @click="ghostStuff.openLink"
    />
    <!-- <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1140.2 245.6 1140.3 303 1181.8 303.6 1181.9 319.9 1189.6 319.9 1189.6 329.3 1253.7 329.4 1253.8 256.9 1322.9 256.8 1322.9 172.5 1193.9 172.8 1194 151 1117.6 151 1117.6 245.5 1140.2 245.6"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1140.2 245.2 1140.3 302.6 1107.4 302.8 1107.3 298.2 1086.4 297.8 1086.2 288.7 1078.5 288.8 1078.2 302.9 1038.5 302.9 1038.1 246.8 996.1 246.8 996.1 151 1117.6 151 1117.5 245.2 1140.2 245.2"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="929.6 330.2 929.6 337.2 843.4 337.4 843.4 256.9 867.2 256.7 867.6 172.8 997.9 172.8 997.9 246.8 1038.5 246.8 1038.5 303.3 998.2 303.2 997.9 330.2 929.6 330.2"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="843.4 415.3 843.3 574.2 941.9 573.8 942.1 494 997.8 493.7 997.8 415.5 843.4 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="843.4 415.5 843.4 337.2 929.6 337.2 929.6 330.4 997.9 330.4 997.9 415.5 843.4 415.5"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="867.2 574.1 941.9 573.8 941.9 493.9 997.8 493.7 997.9 507.7 1028 507.8 1028 560.9 999.7 560.9 999.7 658.2 867.2 658.2 867.2 574.1"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1028.2 512.4 1053.2 512.3 1053.3 507.7 1140.1 507.8 1140.1 572.9 1190.2 572.9 1190.4 631 999.6 630.5 999.7 560.9 1028 560.9 1028.2 512.4"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1346.6 415.3 1346.7 574.2 1253.8 573.8 1253.6 493.9 1231.7 493.7 1231.7 502.7 1190 502.8 1189.8 465.7 1183.7 465.9 1183.7 473.8 1140.2 474 1140.2 415.5 1346.6 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1346.6 415.5 1346.6 256.9 1253.8 256.9 1253.7 329.4 1189.6 329.3 1189.1 336.7 1140.6 336.7 1140.5 415.5 1346.6 415.5"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1322.8 574.1 1253.8 573.8 1253.6 493.9 1231.9 493.7 1231.7 502.7 1190 502.8 1189.6 512.1 1184 512.1 1183.7 507.7 1140.2 507.8 1140.2 573 1190.2 572.9 1190.3 658.2 1322.8 658.2 1322.8 574.1"
      @click="ghostStuff.openLink"
    /> -->
  </svg>
</template>
